import spiner from "../../assets/img/spiner.gif";

const ExportModalComponent = ({
  isModalOpen,
  handleCloseModal,
  handleConfirm,
  isLoading,
}) => (
  <div
    className={`modal ${isModalOpen ? "show" : ""} bg-black-7`}
    style={{ display: isModalOpen ? "block" : "none" }}
  >
    <div className="modal-dialog modal-dialog-centered modal-xl">
      <div className="modal-content rounded-3">
        <div className="modal-header">
          <h5 className="modal-title">Download Excel</h5>
          <button className="close" onClick={handleCloseModal}>
            ×
          </button>
        </div>

        <div className="modal-body text-center">
          {isLoading ? (
            <>
              <p>Please wait... Downloading</p>
              <img src={spiner} height="50px" alt="loading" />
            </>
          ) : (
            <>
              <p>Click below to download Excel</p>
              <button
                className="btn btn-primary"
                onClick={handleConfirm}
              >
                Download
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  </div>
);

export default ExportModalComponent;